// Seller <style> and <link> tags are meant to hit the whole live page. The dashboard
// preview is inline, so here they are confined to the checkout instead of the dashboard.
export const PREVIEW_STYLE_SCOPE = '.cp_status-wrapper';

const STYLE_TAG = /<style\b[^>]*>([\s\S]*?)<\/style>/gi;
const LINK_TAG = /<link\b[^>]*\/?>/gi;
const REL_STYLESHEET = /\brel\s*=\s*["']?\s*stylesheet\b/i;
const HREF = /\bhref\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s"'>]+))/i;

export function scopeCss(css, scope = PREVIEW_STYLE_SCOPE) {
  return `@scope (${scope}) {${css.replaceAll(':root', ':scope')}}`;
}

export function containPreviewStyles(html) {
  if (!html) return { html: '', stylesheets: [] };

  const stylesheets = [];

  const contained = html
    .replace(STYLE_TAG, (match, css) => `<style>${scopeCss(css)}</style>`)
    .replace(LINK_TAG, tag => {
      if (REL_STYLESHEET.test(tag)) {
        const href = tag.match(HREF);
        const url = href?.[1] ?? href?.[2] ?? href?.[3];
        if (url) stylesheets.push(url);
      }
      return '';
    });

  return { html: contained, stylesheets };
}
